
(function () {
  'use strict';

  function getParams(name) {
    return new URL(window.location.href).searchParams.getAll(name);
  }

  function setParams(name, valuesArray) {
    const url = new URL(window.location.href);
    url.searchParams.delete(name);
    valuesArray.forEach(function (v) { if (v) url.searchParams.append(name, v); });
    url.searchParams.delete('page');
    window.history.pushState({}, '', url.toString());
  }

  function clearAllFilters() {
    const url = new URL(window.location.href);
    getAllFilterParams().forEach(function (p) { url.searchParams.delete(p); });
    url.searchParams.delete('page');
    window.history.pushState({}, '', url.toString());
  }

  function getAllFilterParams() {
    const params = [];
    document.querySelectorAll('.cf-filter-group[data-param]').forEach(function (g) {
      const p = g.getAttribute('data-param');
      if (p && params.indexOf(p) === -1) params.push(p);
    });
    return params;
  }

  function parseCardFilters(card) {
    const raw = card.getAttribute('data-filters') || '';
    const result = {};
    raw.split('|||').forEach(function (pair) {
      if (!pair) return;
      const idx = pair.indexOf(':SEP:');
      if (idx === -1) return;
      const key = pair.substring(0, idx).trim();
      const val = pair.substring(idx + 5).trim();
      result[key] = val;
    });
    return result;
  }


  function applyFilters() {
    const allParams = getAllFilterParams();
    const cards = document.querySelectorAll('.cf-card');
    let visible = 0;

    cards.forEach(function (card) {
      const filters = parseCardFilters(card);
      let show = true;

      allParams.forEach(function (param) {
        const active = getParams(param);
        if (active.length === 0) return; 
        const cardVal = filters[param] || '';
        const cardValues = cardVal.split(',').map(function(s){ return s.trim(); });
        const hasMatch = active.some(function(a){
          return cardValues.indexOf(a) !== -1;
        });
        if (!hasMatch) show = false;
      });

      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    const countEl = document.getElementById('cf-count');
    if (countEl) {
      const label = countEl.dataset.label || 'Products';
      countEl.textContent = label + ': ' + visible;
    }

    const emptyEl = document.getElementById('cf-empty');
    if (emptyEl) emptyEl.style.display = visible === 0 ? '' : 'none';

    const hasActive = allParams.some(function (p) { return getParams(p).length > 0; });
    const dot = document.getElementById('cf-active-dot');
    if (dot) dot.style.display = hasActive ? '' : 'none';

    updateActiveTags(allParams);
    syncCheckboxes(allParams);
  }

  function syncCheckboxes(allParams) {
    allParams.forEach(function (param) {
      const active = getParams(param);
      document.querySelectorAll('input[name="' + param + '"]').forEach(function (cb) {
        cb.checked = active.indexOf(cb.value) !== -1;
      });
    });
  }

  function updateActiveTags(allParams) {
    const container = document.getElementById('cf-active-filters');
    if (!container) return;
    container.innerHTML = '';

    let hasAny = false;

    allParams.forEach(function (param) {
      const active = getParams(param);
      active.forEach(function (val) {
        hasAny = true;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cf-tag';
        btn.setAttribute('data-remove-param', param);
        btn.setAttribute('data-remove-val', val);
        btn.innerHTML = val + ' <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 2l8 8M10 2L2 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        btn.addEventListener('click', function () {
          const current = getParams(param).filter(function (v) { return v !== val; });
          setParams(param, current);
          applyFilters();
        });
        container.appendChild(btn);
      });
    });

    if (hasAny) {
        const headerContainer = document.querySelector(".cf-sidebar__header");
        const clearBtnElement = document.getElementById("cf_tag__clear");
        if(clearBtnElement) clearBtnElement.remove();
        const clearBtn = document.createElement('button');
        clearBtn.type = 'button';
        clearBtn.id = 'cf_tag__clear';
        clearBtn.className = 'cf-tag cf-tag--clear';
        clearBtn.textContent = document.getElementById('collection-filters-section')?.dataset.clearLabel || 'Clear all';
        clearBtn.addEventListener('click', function () {
            clearAllFilters();
            applyFilters();
        });
        headerContainer.appendChild(clearBtn);
    }
  }


  document.querySelectorAll('.cf-filter-group[data-param]').forEach(function (group) {
    const param = group.getAttribute('data-param');
    group.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        let current = getParams(param);
        if (cb.checked) {
          current.push(cb.value);
        } else {
          current = current.filter(function (v) { return v !== cb.value; });
        }
        setParams(param, current);
        applyFilters();
      });
    });
  });

  const emptyClear = document.getElementById('cf-empty-clear');
  if (emptyClear) {
    emptyClear.addEventListener('click', function () {
      clearAllFilters();
      applyFilters();
    });
  }

  const form = document.getElementById('filters-form');
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); });

  const sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    const urlSortBy = new URL(window.location.href).searchParams.get('sort_by');
    if (urlSortBy) sortSelect.value = urlSortBy;

    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }


  document.querySelectorAll('.cf-filter-group__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      const body = btn.nextElementSibling;
      if (body) body.classList.toggle('is-collapsed', expanded);
    });
  });

  const openBtn  = document.getElementById('cf-mobile-filter-btn');
  const closeBtn = document.getElementById('cf-sidebar-close');
  const sidebar  = document.getElementById('cf-sidebar');
  const overlay  = document.getElementById('cf-overlay');

  function openSidebar() {
    sidebar.classList.add('is-open');
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }
  function closeSidebar() {
    sidebar.classList.remove('is-open');
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  if (openBtn)  openBtn.addEventListener('click', openSidebar);
  if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
  if (overlay)  overlay.addEventListener('click', closeSidebar);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSidebar(); });

  window.addEventListener('popstate', applyFilters);

  applyFilters();

})();
